export default "__VITE_ASSET__DzvNs8vd__"